function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M6.189 5l3.565-3.565A.841.841 0 008.565.246L5 3.811 1.435.246A.841.841 0 00.246 1.435L3.811 5 .246 8.565a.841.841 0 001.189 1.189L5 6.189l3.565 3.565a.841.841 0 001.189-1.189L6.189 5z",
  fillRule: "evenodd"
});

function SvgCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10
  }, props), _ref);
}

export default SvgCross;